// QA container environment (Dokploy / Traefik) - swapped in by the
// `qa-container` build configuration in angular.json.
//
// The SPA is served from https://qa.ram.syncerewireless.com and the API from
// https://api.qa.ram.syncerewireless.com. Different hostnames, so every API call
// is cross-origin and needs an absolute URL - nginx does not proxy /api here, and
// the API's CORS policy must list the SPA origin (see appsettings.QA.json).
//
// Distinct from environment.qa.ts, which is the LOCAL headless-browser setup
// (`npm run start:qa`, relative /api through proxy.conf.json).
//
// The /api suffix matches environment.ts and environment.prod.ts.
export const environment = {
  production: true,
  apiUrl: 'https://api.qa.ram.syncerewireless.com/api'
};
